import { createListenerMiddleware } from '@reduxjs/toolkit';

import { botsApi } from '~services/api/bots';
import { dialogsApi } from '~services/api/dialogs';
import type { AppDispatch, RootState } from '~store/index';
import { messageReceived } from '~store/utils/message-received';

export const typingIndicatorDataProcessing = createListenerMiddleware();

typingIndicatorDataProcessing.startListening({
	matcher: dialogsApi.endpoints.sendMessage.matchFulfilled,
	effect: (action, listenerApi) => {
		const recipientId = action.meta.arg.originalArgs.recipientId;
		const userId = action.meta.arg.originalArgs.id;

		listenerApi.dispatch(
			botsApi.util.updateQueryData('getContacts', { userId }, (draft) => {
				const bot = Object.values(draft.contacts).find(
					({ clientId }) => clientId === +recipientId
				);
				if (!bot) {
					return;
				}
				bot.isTyping = true;
			}) as AppDispatch
		);
	},
});

typingIndicatorDataProcessing.startListening({
	actionCreator: messageReceived,
	effect: (action, listenerApi) => {
		const recipientId = action.payload;
		const { id: userId } = (listenerApi.getState() as RootState).auth.info;
		listenerApi.dispatch(
			botsApi.util.updateQueryData('getContacts', { userId }, (draft) => {
				const bot = Object.values(draft.contacts).find(
					({ clientId }) => clientId === +recipientId
				);
				if (!bot) {
					return;
				}
				bot.isTyping = false;
			}) as AppDispatch
		);
	},
});
